export default {
  'pagePaymentSuccess.success.title': 'Renewal Successful',
  'pagePaymentSuccess.success.desc':
    'Congratulations! You have successfully renewed your current subscription.',
  'pagePaymentSuccess.success.button': 'View Payment History',
  'pagePaymentSuccess.fail.title': 'Renewal Failed',
  'pagePaymentSuccess.fail.desc': 'Your subscription renewal has failed.',
  'pagePaymentSuccess.fail.button': 'Try Again',
};
